import React, { createContext, useContext, useState, useEffect } from 'react';
import { apiGet } from '../utils/apiClient';

const DocumentTypesContext = createContext();

export const DocumentTypesProvider = ({ children }) => {
  const [documentTypes, setDocumentTypes] = useState([]);
  const [error, setError] = useState(null);

  const fetchDocumentTypes = async () => {
    setError(null);
    try {
      const data = await apiGet('/api/document-types');
      setDocumentTypes(data);
    } catch (err) {
      setError(err.message);
    }
  };

  useEffect(() => {
    fetchDocumentTypes();
  }, []);

  return (
	<DocumentTypesContext.Provider
	  value={{ documentTypes, error, refreshDocumentTypes: fetchDocumentTypes }}
	>
	  {children}
	</DocumentTypesContext.Provider>
  );
};

export const useDocumentTypes = () => {
  const context = useContext(DocumentTypesContext);
  if (!context) {
    throw new Error('useDocumentTypes must be used within a DocumentTypesProvider');
  }
  return context;
};